import { css } from 'styled-components';
import {
  getSpacing, SpacingName, TypographyName, getTypography, ThemedFunctor, FontWeight, ellipsis,
} from '@doveit/bricks';

export const base = css`
  cursor: pointer;
  overflow: hidden;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: ${FontWeight.BOLD};

  a {
    text-decoration: none;
    color: ${theme.palettes.neutrals.darkest};
    text-transform: capitalize;
  }

  & > span {
    ${ellipsis()}
  }
`;

export const suburb: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  color: ${theme.palettes.neutrals.dark};

  & > span {
    ${ellipsis()}
  }
`;

export const price: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  color: ${theme.palettes.brand.primary};
  white-space: nowrap;
`;

export const details: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: flex;
  align-items: center;
`;

export const highlights: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  align-items: center;

  &:last-child {
    margin-left: .5rem;
    border-left: 1px solid ${theme.palettes.neutrals.light};
  }
`;

export const highlight: ThemedFunctor = ({
  theme,
}) => css`
  border-right: 1px solid ${theme.palettes.neutrals.light};
  padding: 0 .5rem;
  display: flex;
  flex-direction: column;

  &:last-child {
    border-right: none;
    padding-right: 0;
  }
`;

export const highlightValue = css`
  line-height: 1;
  margin-top: 3px;
`;

export const highlightLabel: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALLER)}
  line-height: 1;
  color: ${theme.palettes.neutrals.dark};
`;

export const image: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
`;
